import {createContext} from "react";

// Pass up to 2 values - there shouldn't be anymore than that
export const TranslationColumn1Context = createContext({});